export default __webpack_public_path__ + "static/equipment-1-175250a9ce3546e6946eaae67a042ba1.jpg";